import React, { useState } from "react";
import { SketchPicker } from "react-color";

export default function ColorPicker({ defaultColor = "", onColorChange = f => f}) {
  const [color, setColor] = useState(defaultColor);
  const [showPicker, setShowPicker] = useState(false);

  const handleChangeComplete = (color) => {
    console.log("color", color.hex);
    setColor(color.hex);
    onColorChange(color.hex);
  };

  const styles = {
      color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px',
        background: color,
        border: '1px solid black',
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
        top: '0',
        left: '0'
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
  }

  return (
    <div>
      <div>
        <div style={styles.swatch} onClick={() => setShowPicker(!showPicker)}>
          <div style={styles.color} />
        </div>
        <div>
          <a className="small text-muted" onClick={() => handleChangeComplete('')}>Reset</a>
        </div>
        {showPicker && (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={() => setShowPicker(false)} />
            <SketchPicker
              color={color}
              onChangeComplete={handleChangeComplete}
            />
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/ColorPicker/index.js